import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ProductContainerEntityModel} from "../product-container-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-product-container-edit-page",
    templateUrl: "./product-container-edit-page.component.html",
    providers: [provideEntityModel(ProductContainerEntityModel)]
})
export class ProductContainerEditPageComponent extends AbstractEditPage {
    constructor(public model: ProductContainerEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
